module.exports = __webpack_public_path__ + "static/logo-29770f5eac2d6933bc3c9e9b58cbd529.svg";